export const PROCESSING_DRIVER_LATE = "PROCESSING_DRIVER_LATE";
export const PROCESSING_BULK_DRIVER_LATE = "PROCESSING_BULK_DRIVER_LATE";
export const GET_DRIVER_LATE = "GET_DRIVER_LATE";
export const CREATE_DRIVER_LATE = "CREATE_DRIVER_LATE";
export const DELETE_DRIVER_LATE = "DELETE_DRIVER_LATE";
